import { getSlot } from "@/mds/utils/slots";
import { MDSPanelHeaderProps, MDSPanelHeaderSlotName } from "./panel-header.types";
import {
  Wrapper,
  HeadingArea,
  SubsectionArea,
  ActionsArea,
  StyledHeading,
} from "./panel-header.style";

export const MDSPanelHeader = ({ children, bottomBorderColor }: MDSPanelHeaderProps) => {
  const headingSlot = getSlot(children, MDSPanelHeaderSlotName.Heading);
  const subsectionSlot = getSlot(children, MDSPanelHeaderSlotName.Subsection);
  const actionsSlot = getSlot(children, MDSPanelHeaderSlotName.Actions);

  return (
    <Wrapper data-component="MDSPanelHeader" $bottomBorderColor={bottomBorderColor}>
      <HeadingArea data-component="HeadingArea">
        <StyledHeading data-component="StyledHeading" $hasSubsection={!!subsectionSlot}>
          {headingSlot}
        </StyledHeading>
      </HeadingArea>
      {subsectionSlot && <SubsectionArea>{subsectionSlot}</SubsectionArea>}
      {actionsSlot && <ActionsArea data-component="ActionsArea">{actionsSlot}</ActionsArea>}
    </Wrapper>
  );
};
